import AxiosInstance from "../config/axiosInterceptor";
import { ContentApiRoutes } from "../../navigation/NavConstant";

export interface loginInterface {
  username: string;
  password: string;
}

export const AuthServices = {
  login: ({ username, password }: loginInterface) =>
    AxiosInstance.post(
      ContentApiRoutes.LOGIN_ADMIN,
      { username, password },
      {}
    ),
};
